import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FiatTransaction } from "@modules/+new/transactions/domain/entities/fiat-transaction.model";
import { TransactionsBridgeService } from "@modules/+new/transactions/domain/+state/transactions-bridge.service";
import { TransactionsRemote } from "@modules/+new/transactions/infrastructure/transactions.remote";
import { CreateDepositTransactionRequest } from "@modules/+new/transactions/domain/entities/create-deposit-transaction-request.model";
import { ConfirmDepositTransactionRequest } from "@modules/+new/transactions/domain/entities/confirm-deposit-transaction-request.model";
import { ApproveDepositTransactionRequest } from "@modules/+new/transactions/domain/entities/approve-deposit-transaction-request.model";
import { FiatTransactionPayment } from "@modules/+new/transactions/domain/entities/fiat-transaction-payment.model";
import { FiatTransactionDepositResponse } from "@modules/shared/domain/entities/fiat-transaction-deposit-response.model";

@Injectable({
	providedIn: "any"
})
export class TransactionsFacade {
	public constructor(
		private readonly bridgeService: TransactionsBridgeService,
		private readonly remote: TransactionsRemote
	) {}

	public getFiatTransactions$(): Observable<FiatTransaction[]> {
		return this.bridgeService.getFiatTransactions$();
	}

	public getFiatTransaction$(walletId: string, transactionId: string): Observable<FiatTransaction> {
		return this.bridgeService.getFiatTransaction$(walletId, transactionId);
	}

	public getFiatTransactionPaymentByWallet$(
		walletId: string,
		transactionId: string
	): Observable<FiatTransactionPayment> {
		return this.remote.getTransactionPaymentByWallet$(walletId, transactionId);
	}

	public createDepositTransaction$(request: CreateDepositTransactionRequest): Observable<FiatTransaction> {
		return this.remote.createDepositTransaction$(request);
	}

	public confirmDepositTransaction$(request: ConfirmDepositTransactionRequest): Observable<FiatTransaction> {
		return this.remote.confirmDepositTransaction$(request);
	}

	public approveDepositTransaction$(request: ApproveDepositTransactionRequest): Observable<void> {
		return this.remote.approveDepositTransaction$(request);
	}

	public getDepositTransactionResponse$(depositId: string): Observable<FiatTransactionDepositResponse> {
		return this.remote.getDepositTransactionResponse$(depositId);
	}
}
